import { useEffect, useState } from 'react';

const supportsPrefersColorScheme = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').media !== 'not all';

const getSystemDarkMode = () => window.matchMedia('(prefers-color-scheme: dark)').matches;

const getTimeDarkMode = () => {
  const hour = new Date().getHours();
  return hour >= 18 || hour < 6;
};

export function useAutoDarkMode() {
  const [darkMode, setDarkMode] = useState(supportsPrefersColorScheme() ? getSystemDarkMode() : getTimeDarkMode());

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    if (supportsPrefersColorScheme()) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => setDarkMode(getSystemDarkMode());
      handleChange();
      mediaQuery.addEventListener('change', handleChange);
      cleanup = () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      const updateDarkMode = () => setDarkMode(getTimeDarkMode());
      updateDarkMode();
      const interval = setInterval(updateDarkMode, 60 * 1000);
      cleanup = () => clearInterval(interval);
    }
    return () => {
      if (cleanup) cleanup();
    };
  }, []);

  return darkMode;
}
